<template>
  <v-app>
    <main-app-bar></main-app-bar>
    <v-main class="hk-app-bg" :style="{ backgroundImage: 'url(' + baseImg + ')' }">
      <section class="hk-section">
        <div class="hk-wrap">
          <h1 class="hk-heading hk-heading--accent mb-10">Rólunk</h1>

          <v-row align="center" justify="center" class="mb-4">
            <v-col cols="12" md="6">
              <v-card class="hk-card about-image-card">
                <img :src="machine" class="about-image" alt="Hímzőgépünk" />
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card class="hk-card pa-6 pa-md-8">
                <h2 class="hk-subheading text-md-left mb-4">Üdvözöljük oldalunkon!</h2>
                <div class="hk-body">
                  <p class="mb-4">
                    Örülünk, hogy ellátogatott hozzánk. Vállalkozásunk fő profilja a gépi hímzett termékek készítése –
                    legyen az ruha, táska, párna, sapka vagy törölköző.
                  </p>
                  <p class="mb-4">
                    A hímzett termékek nem csak egyediek, szépek és elegánsak, de divatosak is egyben. Tökéletes választás
                    ünnepre, eseményre, ajándékként vagy személyes használatra. A gépi hímzés előnye más technológiával
                    szemben, hogy tartós: nem fakul ki és nem kopik le.
                  </p>
                  <p class="mb-0">
                    Egyedi elképzelése van? Abban is szívesen segítünk!
                  </p>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <h2 class="hk-heading hk-heading--accent mt-12 mb-10">Keressen minket</h2>
          <v-card class="hk-card pa-4 pa-md-8">
            <connection-row></connection-row>
          </v-card>
        </div>
      </section>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import MainAppBar from "@/components/MainAppBar.vue";
import ConnectionRow from "@/components/ConnectionRow.vue";

@Options({
  components: {ConnectionRow, MainAppBar},
  data() {
    return {
      machine: require("@/assets/company.png"),
      baseImg: require("@/assets/base.png"),
    };
  }
})
export default class AboutCompany extends Vue {
}
</script>

<style scoped>
.about-image-card {
  overflow: hidden;
  padding: 0;
}

.about-image {
  display: block;
  width: 100%;
  height: auto;
  max-height: 520px;
  object-fit: cover;
  object-position: center;
}
</style>
